import dayjs from 'dayjs';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { UserState } from '@/types/UserState';

export const useUserStore = create<UserState>()(
  persist(
    (set) => ({
      welcomeDialogOpen: true,
      notificationDialogOpen: false,
      notificationsRead: [],
      prioritizedReportIds: [],

      actions: {
        setWelcomeDialogOpen: (welcomeDialogOpen) => set({ welcomeDialogOpen }),
        setNotificationDialogOpen: (notificationDialogOpen) => set({ notificationDialogOpen }),
        addNotificationRead: (id) =>
          set(({ notificationsRead }) => ({ notificationsRead: [...notificationsRead, id] })),
        resetNotificationsRead: () => set({ notificationsRead: [] }),

        addPrioritizedReportId: (id, type) =>
          set(({ prioritizedReportIds }) => ({
            prioritizedReportIds: [...prioritizedReportIds, { id, type, date: dayjs().toISOString() }],
          })),
      },
    }),
    {
      name: 'mpris-bw/user',
      version: 1,

      partialize: ({ actions, ...rest }) => rest,
    },
  ),
);
